/**
 * Client-side view of safe mode. `/api/safe-mode.js` stamps `data-safe-mode` on
 * <html> before React mounts; see server/src/safe-mode.ts.
 *
 * Mirrors the selector in index.css: anything other than an explicit "0" counts as
 * ON, so a missing attribute (script blocked, 404, dropped request) fails closed.
 * Keep the two in step — if this says "off" while the CSS says "on", the UI blurs
 * media but still lets it escape through Picture-in-Picture.
 */
export function isSafeMode(): boolean {
  // No document at all — a render check under Node, or any non-browser evaluation. That
  // is one more way of not having read an explicit "0", so it answers the same way the
  // missing-attribute case does: ON. Returning false here would be the one place in the
  // safe-mode path that fails OPEN, and it would do it silently.
  if (typeof document === "undefined") return true;
  return document.documentElement.dataset.safeMode !== "0";
}
